import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["template", "container"]
  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", crypto.randomUUID())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }
  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-question]")
    const destroy = wrapper.querySelector('input[name$="[_destroy]"]')
    destroy.value = "1"
    wrapper.hidden = true
    wrapper.querySelectorAll("input:not([type=hidden]), textarea, select").forEach(input => { input.required = false })
  }
}
